export const createDashboardSlug = (
  accountId: string,
  advertiserId: string,
  userId: string,
  workspaceTypeId?: number,
): string => {
  return `${accountId}${advertiserId}${userId}${workspaceTypeId ?? 0}`.padEnd(22, '0');
};
